import {
  GroupIcon,
  ListIcon,
  SlidersHorizontalIcon,
  TextCursorInputIcon,
  Settings2Icon,
} from "lucide-react";

import { ComponentType } from "@/queries/models/types";

export const ParameterIcon = ({ type }: { type?: ComponentType }) => {
  if (!type) {
    return null;
  }

  switch (type) {
    case ComponentType.SLIDER:
      return <SlidersHorizontalIcon className="h-5 w-5 text-gray-500" />;
    case ComponentType.DROPDOWN:
      return <ListIcon className="h-5 w-5 text-gray-500" />;
    case ComponentType.INPUT:
      return <TextCursorInputIcon className="h-5 w-5 text-gray-500" />;
    case ComponentType.GROUP:
      return <GroupIcon className="h-5 w-5 text-gray-500" />;
    default:
      return <Settings2Icon className="h-5 w-5 text-gray-500" />;
  }
};
